// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5755":"12e7accb","6947":"88834f1c"}[chunkId] + ".chunk.css";
};